var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStepsBackground1 = function SvgStepsBackground1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 958,
    height: 939,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#steps_background_1_svg__a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#steps_background_1_svg__b)",
    d: "m-130.255 199 341.473 140.005s377.586 42.557 505.344 214.536C966.858 890.473-56.101 1301-56.101 1301L-1032 553.541-130.255 199Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steps_background_1_svg__b",
    x1: -138.006,
    x2: -138.006,
    y1: 1301,
    y2: 199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#885AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00193F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "steps_background_1_svg__a",
    width: 2191.32,
    height: 1505.32,
    x: -1233.66,
    y: -2.658,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1364_1673",
    stdDeviation: 100.829
  })))));
};
export default SvgStepsBackground1;